import { render, staticRenderFns } from "./first-stake.vue?vue&type=template&id=ae451034&scoped=true&"
import script from "./first-stake.vue?vue&type=script&lang=ts&"
export * from "./first-stake.vue?vue&type=script&lang=ts&"
import style0 from "./first-stake.vue?vue&type=style&index=0&id=ae451034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae451034",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSheet,VTextField})
